export class ViewApplicationLocationBpiConstants {
    static STEP_TITLE = "Location";
    static PROPERTY_HEADING_LABEL = "Property details";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static COPY_OWNER_LABEL = "Copy owner to applicant";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static APPLICANT_FORM_CONTROL_NAME = "applicantRecipient";
    static APPLICANT_AGENT_FORM_CONTROL_NAME = "applicantAgentRecipient";
    static PROPERTIES_FORM_CONTROL_NAME = "properties";
    static CENTROID_FORM_CONTROL_NAME = "centroid";
    static BPAMS_APPLICATION_REFERENCE_NUMBER_CONTROL = "bpamsReferenceNumber";
    static HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME = "hasBpamsReferenceNumber";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static ERF_SIZE_CONTROL = "erfSize";
    static TITLE_DEED_CONTROL = "titleDeed";
    static OWNER_CONTROL = "owners";
    static HAS_BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER = "Do you have a building plan reference number?";
    static DESCRIPTION_TEXT_PLACEHOLDER = "Description";
    static BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER = "Building plan reference number?";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size (m²)";
    static TITLE_DEED_TEXT_PLACEHOLDER = "Title deed";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static NO_OWNERS_SELECTED_MESSAGE = "Please select an owner to copy to applicant";
    static MULTIPLE_OWNERS_SELECTED_MESSAGE = "Multiple owners have been selected, please select only one to copy to applicant";
    static VERIFY_LABEL = "Verify";
    static VERIFICATION_MESSAGE = "Building plan reference number verification was successful";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static PROPERTY_FORM_NAME = "propertiesForm";
}
